/* GLOBAL */
.button {
  border-radius: var(--border-radius-medium);
  box-shadow: var(--box-shadow);
  cursor: pointer;
  display: inline-block;
  font-size: 0.9rem;
  font-weight: 700;
  outline: none;
  overflow: hidden;
  padding: 0;
  position: relative;
  text-align: center;
  transition: all 0.25s;
  user-select: none;
}

.hint {
  background-color: var(--theme-dark-red);
  border-radius: 9px;
  box-sizing: border-box;
  color: var(--theme-white);
  font-size: 12px;
  font-weight: 700;
  height: 18px;
  line-height: 18px;
  min-width: 18px;
  padding: 0 4px;
  position: absolute;
  right: -5px;
  top: -5px;
}

.button svg {
  display: inline-block;
}

.button.text svg {
  margin-right: 0.5rem;
}

.button.disabled {
  cursor: not-allowed;
  opacity: 0.4;
}

.loading {
  cursor: not-allowed;
  opacity: 0.5;
}

.loading .text {
  opacity: 0;
}

.loading .icon {
  opacity: 0;
}

.loader,
.loader div {
  border-width: 3px !important;
  margin: 0 !important;
}

.loader {
  left: 50%;
  position: absolute !important;
  transform: translateX(-50%);
}

/* THEME - PRIMARY */
.button.primary {
  background: var(--comp-button-primary-background-color);
  border: 2px solid var(--comp-button-primary-background-color);
  color: var(--comp-button-primary-text-color);
}

.button.primary:hover {
  background: var(--comp-button-primary-hover-background-color);
  color: var(--comp-button-primary-hover-text-color);
}

.button.primary.active {
  background: var(--comp-button-primary-active-background-color);
  border: 2px solid var(--comp-button-primary-active-background-color);
  color: var(--comp-button-primary-active-text-color);
}

.button.primary.active:hover {
  opacity: 0.9;
}

/* THEME - SECONDARY */
.button.secondary {
  background: var(--comp-button-secondary-background-color);
  border: 2px solid var(--comp-button-secondary-background-color);
  color: var(--comp-button-secondary-text-color);
}

.button.secondary:hover {
  background: var(--comp-button-secondary-hover-background-color);
  color: var(--comp-button-secondary-hover-text-color);
}

.button.secondary.active {
  background: var(--comp-button-secondary-active-background-color);
  border: 2px solid var(--comp-button-secondary-active-background-color);
  color: var(--comp-button-secondary-active-text-color);
}

.button.secondary.active:hover {
  opacity: 0.9;
}

/* THEME - TRANSPARENT */
.button.transparent {
  background: transparent;
  border: 2px solid var(--comp-button-transparent-color);
  color: var(--comp-button-transparent-color);
}

.button.transparent:hover {
  opacity: 0.85;
}

.button.transparent.active {
  background: transparent;
  border: 2px solid var(--comp-button-transparent-active-color);
  color: var(--comp-button-transparent-active-color);
}

.button.transparent.active:hover {
  opacity: 0.9;
}

/* SIZE - SMALL */
.button.small {
  font-size: 0.8rem;
  height: 26px;
  line-height: 26px;
  min-width: 26px;
}

.button.small.text {
  padding: 0 6px;
}

.button.small .loader {
  top: 2px;

  --size: 26px !important;
  --color: var(--theme-dark-blue);
}

/* SIZE - MEDIUM */
.button.medium {
  font-size: 0.9rem;
  height: 36px;
  line-height: 36px;
  min-width: 36px;
}

.button.medium.text {
  padding: 0 12px;
}

.button.medium .loader {
  top: 6px;

  --size: 28px !important;
  --color: var(--theme-dark-blue);
}

/* SIZE - LARGE */
.button.large {
  font-size: 1rem;
  height: 42px;
  line-height: 42px;
  min-width: 42px;
}

.button.large.text {
  padding: 0 32px;
}

.button.large .loader {
  top: 9px;

  --size: 28px !important;
  --color: var(--theme-dark-blue);
}

@media screen and (width <=850px) {
  .iconOnlyOnMobile .text {
    display: none;
  }

  .iconOnlyOnMobile.button.text {
    padding: 0 !important;
  }

  .iconOnlyOnMobile svg {
    margin-right: 0 !important;
  }
}